import { mapActions } from 'vuex'

var time_codes_mixin = {
  methods: {
    ...mapActions({
      updateStartTime: 'timeCodes/updateStartTime',
      updateEndTime: 'timeCodes/updateEndTime'
    })
  }
}

export default time_codes_mixin;



// WEBPACK FOOTER //
// ./src/mixin/timeCodes.js